import { api } from '@services';
import EquipmentInventory, {
  IEquipmentInventory,
  IEquipmentInventoryApiModel,
} from '@models/EquipmentInventory.model';
import { IPaginationResult } from '@models/Equipment.model';
import { InventoryQueryParams } from './makeParamsObject';

export interface IFilterRequest {
  modelNames?: string[];
  tagNames?: string[];
  statusId?: string[];
  usersId?: string[];
  manufactorNames?: string[];
  // NOTE: These two are strings!
  purchasedDateStart?: Date;
  purchasedDateEnd?: Date;
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
}
export interface IPagination {
  page: number;
  limit: number;
  search?: string;
}
interface IRequest {
  /* Use  makeParamsObject to generate this. */
  params: Partial<InventoryQueryParams>;
}

const getEquipments = async ({
  params,
}: IRequest): Promise<IPaginationResult<IEquipmentInventory>> => {
  const reqParams = new URLSearchParams(params as InventoryQueryParams); //  The partial does not have  properties set as undefined.

  const { data: equipments } = await api.get<
    IPaginationResult<IEquipmentInventoryApiModel>
  >(`/equipments`, {
    params: reqParams,
  });

  return EquipmentInventory.fromArrayPaginatedApiModel(equipments);
};

export { getEquipments };
